module.exports = __webpack_public_path__ + "static/media/ze.811e2378.png";